import { call, put, takeLatest } from "redux-saga/effects";
import { tongHopNamApi } from "../../../api/tong-hop-diem/tongHopNamApi";
import { ITongHopNamRequest } from "../../../model/request/tong-hop-diem/ITongHopNamRequest";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { eTongHopNamActionIds, ITongHopNamActionTypes } from "../../action-types/tong-hop-diem/ITongHopNamActions";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

export function* tongHopNamSaga(): any {
    yield takeLatest(eTongHopNamActionIds.LOAD_START, loadWorker);
}

function* loadWorker(action: ITongHopNamActionTypes ) {
    const request  = action.payload as ITongHopNamRequest;
    const response: IBaseResponse = yield call(tongHopNamApi.Select,request);
    if (response.is_success) {
      yield put(rootActions.tongHopDiem.tongHopNam.LOAD_SUCCESS(toLowerCaseDeep(response.data)))
    } else {
       yield put(rootActions.tongHopDiem.tongHopNam.LOAD_ERROR(response.message ?? "Có lỗi"))
    }
}